var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 11.0824C15.25 11.4507 15.1037 11.804 14.8432 12.0645C14.5827 12.3249 14.2295 12.4712 13.8611 12.4712H5.52778L2.75 15.249V4.13791C2.75 3.76956 2.89633 3.41629 3.1568 3.15582C3.41726 2.89535 3.77053 2.74902 4.13889 2.74902H13.8611C14.2295 2.74902 14.5827 2.89535 14.8432 3.15582C15.1037 3.41629 15.25 3.76956 15.25 4.13791V11.0824Z",
    stroke: "#585969",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.333 5.52092C12.333 5.14314 12.0219 4.83203 11.6367 4.83203L5.91079 4.83203C5.53301 4.83203 5.2219 5.14314 5.2219 5.52092C5.2219 5.90611 5.53301 6.21722 5.91079 6.21722L11.6367 6.21722C12.0219 6.21722 12.333 5.90611 12.333 5.52092Z",
    fill: "#585969"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83301 8.02092C9.83301 7.64314 9.63139 7.33203 9.38178 7.33203L5.67111 7.33203C5.42629 7.33203 5.22467 7.64314 5.22467 8.02092C5.22467 8.40611 5.42629 8.71722 5.67111 8.71722L9.38178 8.71722C9.63139 8.71722 9.83301 8.40611 9.83301 8.02092Z",
    fill: "#585969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.f832f557481e9577e9796dfd9d37ce0a.svg";
export { ForwardRef as ReactComponent };